import { jsx as _jsx } from "react/jsx-runtime";
import deepmerge from 'deepmerge';
import React, { createContext, useContext, useEffect } from 'react';
import { useAppSelector, withRedux } from '../redux';
import { deepmergeArrayIdMerge } from '../utils/deepmerge';
const WidgetContext = createContext(undefined);
export const WidgetProvider = withRedux(({ children, widgets }) => {
    const dynamicData = useAppSelector(state => state.widget.nodes);
    const [mergedData, setMergedData] = React.useState(widgets);
    useEffect(() => {
        const merged = deepmerge(widgets, dynamicData || [], {
            arrayMerge: deepmergeArrayIdMerge
        });
        setMergedData(merged);
    }, [widgets, dynamicData]);
    return (_jsx(WidgetContext.Provider, { value: mergedData, children: children }));
});
export function useWidgetContext() {
    const context = useContext(WidgetContext);
    if (context === undefined) {
        throw new Error('useWidgetContext must be used within a WidgetProvider');
    }
    return context;
}
